/* unplugin-vue-components disabled */import { render } from "./QueryOrder.vue?vue&type=template&id=3b99115c&scoped=true"
import script from "./QueryOrder.vue?vue&type=script&lang=js"
export * from "./QueryOrder.vue?vue&type=script&lang=js"

import "./QueryOrder.vue?vue&type=style&index=0&id=3b99115c&scoped=true&lang=css"

import exportComponent from "E:\\myprogram\\52haoma_new\\new-haoma52\\haoma52-index\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b99115c"]])

export default __exports__